// extracted by mini-css-extract-plugin
export default {"mySelectArrow":"profileselectinput_mySelectArrow__YiPa4","select":"profileselectinput_select__3tu4T"};